import { getRuntime } from '../runtime';
import type { RuntimeKind } from '../types';
import { createPlatformDevice } from './device';
import type { PlatformServices } from './types';
import { createPlatformStorage } from './storage';
import { createPlatformPrinter } from './printer';
import { createPlatformPayments } from './payments';
import { createPlatformDatabase } from './database';

/**
 * The composition root proper: the one place the five platform services are
 * resolved, and the only correct answer to "which implementation runs here".
 *
 * Resolution is by the capability table, never by asking Capacitor what
 * platform it is (AMENDMENT A3.1). Nothing is memoized across calls so a test
 * that repins the runtime gets services for the runtime it pinned; the objects
 * are small literals.
 */
export function createPlatformServices(kind: RuntimeKind): PlatformServices {
  return {
    runtimeKind: kind,
    payments: createPlatformPayments(kind),
    printer: createPlatformPrinter(kind),
    database: createPlatformDatabase(kind),
    device: createPlatformDevice(kind),
    storage: createPlatformStorage(kind),
  };
}

export function getPlatformServices(): PlatformServices {
  return createPlatformServices(getRuntime().kind);
}

export const getPlatformPayments = () => getPlatformServices().payments;
export const getPlatformPrinter = () => getPlatformServices().printer;
export const getPlatformDatabase = () => getPlatformServices().database;
export const getPlatformDevice = () => getPlatformServices().device;
export const getPlatformStorage = () => getPlatformServices().storage;

export * from './types';
